import React from "react";
import styled from "styled-components";
import { IconProps } from "@xsolla/xui-primitives-core";
import { createFilteredElement } from "./filterDOMProps";

const FilteredDiv = createFilteredElement("div");

const StyledIcon = styled(FilteredDiv)<IconProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props) =>
    typeof props.size === "number" ? `${props.size}px` : props.size || "24px"};
  height: ${(props) =>
    typeof props.size === "number" ? `${props.size}px` : props.size || "24px"};
  color: ${(props) => props.color || "currentColor"};

  svg {
    width: 100%;
    height: 100%;
    fill: none;
    stroke: currentColor;
  }
`;

export const Icon: React.FC<IconProps> = ({
  children,
  testID,
  "data-testid": dataTestId,
  ...props
}) => {
  return (
    <StyledIcon data-testid={dataTestId || testID} {...props}>
      {children}
    </StyledIcon>
  );
};
